const API_URL = "https://api.glamcompany.in/api/v1/";

export {
    API_URL
}
